<mat-card>
  <div class="table-item" *ngFor="let displayColumn of columnsToDisplay">
    {{displayColumn.label}}
  </div>
</mat-card>
<div class="table-body">
  <mat-accordion [togglePosition]="'before'" [multi]="true" *ngIf="isGroupDisplay; else flatList">
    <div *ngIf="outputGroups$ | async as groups">
      <mat-expansion-panel #panel expanded *ngFor="let group of groups" hideToggle="true">
        <mat-expansion-panel-header class="group-title" [ngClass]="{'selected': isGroupSelected(group),'dark-theme': isDarkTheme$ | async}"
                                    (click)="panel.toggle();selectGroup(group, $event)" [collapsedHeight]="'50px'" [expandedHeight]="'50px'">
          <mat-panel-title class="group-label">
            <mat-icon id="expansion-toggle-button" (click)="panel.toggle()" [ngClass]="{'rotate--180': panel.expanded}">keyboard_arrow_down</mat-icon>
            <div>{{group.description}}</div>

          </mat-panel-title>

        </mat-expansion-panel-header>
        <div *ngFor="let element of group.outputs">
          <app-panel-output-item [displayColumns]="groupsColumns" [output]="element" [outputGroup]="group">
          </app-panel-output-item>
        </div>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</div>
<ng-template #flatList>
  <div *ngIf="outputs$ | async as outputs">
    <div *ngFor="let element of outputs">
      <app-panel-output-item [displayColumns]="flatListColumns" [output]="element">
      </app-panel-output-item>
    </div>
  </div>
</ng-template>